import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Group} from '../../../graphql/groups.datatypes';
import {gqlGroup} from '../getGroup.api';
import {UpdateGroupInput} from './updateGroup.api';

interface LimitedUpdateGroupData {
    __typename?: string,
    limitedUpdateGroup: Group
}

export const LIMITED_UPDATE_GROUP_MUTATION = gql`
    mutation limitedUpdateGroup($data: UpdateGroupInput!) {
        limitedUpdateGroup(data: $data) {
            ${gqlGroup}
        }
    }
`;

export const limitedUpdateGroup = () => useMutation<LimitedUpdateGroupData, UpdateGroupInput>(
  LIMITED_UPDATE_GROUP_MUTATION,
  {
      update: (cacheRef) => {
          updateCacheByType('Group')(cacheRef);
          updateCacheByType('User')(cacheRef);
      },
  }
);

export default limitedUpdateGroup;